import { ReactNode } from 'react';

import { useCopyToClipboard } from 'hooks/useCopyToClipboard';

import { Button } from 'components/parts/Button/Button';
import { Dialog } from 'components/parts/Dialog/Dialog';
import dialogStyles from 'components/parts/Dialog/Dialog.module.scss';
import { Paragraph } from 'components/parts/Paragraph/Paragraph';

import styles from './CopyButton.module.scss';

type CopyButtonProps = {
  text: string;
  buttonText?: string;
  successMessage?: ReactNode;
  errorMessage?: string;
  styleType?: 'primary' | 'secondary' | 'secondaryMini' | 'ghost' | 'text';
  disabled?: boolean;
  addClass?: string[];
};

export const CopyButton = ({
  text,
  buttonText = 'コピーする',
  successMessage = 'コピーしました',
  errorMessage = 'コピーに失敗しました',
  styleType = 'secondary',
  disabled = false,
  addClass = [],
}: CopyButtonProps) => {
  const { availableClipboard, handleCopyText, openDialog, setOpenDialog, message } =
    useCopyToClipboard({ text, successMessage, errorMessage });

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <>
      <Button
        text={buttonText}
        styleType={styleType}
        addClass={addClass}
        disabled={disabled || !availableClipboard}
        handleClick={handleCopyText}
      />
      {openDialog && (
        <Dialog
          isOpen={openDialog}
          handleClose={handleCloseDialog}
          easyCloseMode={false}
          addClass={['errorDialog']}
        >
          <div className={styles.errorDialog}>
            <div className={`${dialogStyles.content} ${styles.dialogBody}`}>
              <div className={styles.dialogBody}>
                {typeof message === 'string' ? <Paragraph>{message}</Paragraph> : message}
              </div>
            </div>
            <Button text="OK" styleType="primary" handleClick={handleCloseDialog} />
          </div>
        </Dialog>
      )}
    </>
  );
};
